import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type {
  InsertChildObligationInput,
  InsertObligationMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertObligationDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertObligationTRPCInput = Omit<
  InsertChildObligationInput,
  'schedule' | 'Adherence'
> &
  ScheduleTRPCInput & {
    Adherence: string;
  };

export const useInsertObligation = createMutationHook({
  name: 'insertObligation',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligation.insert.mutationOptions({ onSuccess }),
  mapInput: ({
    schedule,
    ...rest
  }: InsertChildObligationInput): InsertObligationTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
    Adherence: rest.Adherence ?? '',
  }),
  invalidate: (trpc) => [
    trpc.frontend.obligation.register.queryKey(),
    trpc.frontend.obligation.getById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertObligationMutation => ({
    insertChildObligation: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertObligationDocument,
  graphqlVariables: (input: InsertChildObligationInput) => ({ object: input }),
  evictFields: ['obligation'],
  refetchQueries: [
    namedOperations.Query.getObligationById,
    namedOperations.Query.getObligationsByType,
  ],
});
